export default {
  incidentReports: 'INCIDENT_REPORTS',
  incidentReport: 'INCIDENT_REPORT',
  createIncidentReport: 'CREATE_INCIDENT_REPORT',
  updateIncidentReport: 'UPDATE_INCIDENT_REPORT',
  deleteIncidentReport: 'DELETE_INCIDENT_REPORT',
  reportLink: 'REPORT_LINK',
  pendingIncidentReport: 'PENDING_INCIDENT_REPORT',
  approveIncidentReport: 'APPROVE_INCIDENT_REPORT',
};
